import { render, staticRenderFns } from "./TheHearingAppLeaveGrantedPg.vue?vue&type=template&id=81e3ed1c&scoped=true"
import script from "./TheHearingAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./TheHearingAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e3ed1c",
  null
  
)

export default component.exports